/**
 * Registry of "is there unsaved work right now?" getters.
 *
 * Every surface that guards hard navigation through `useUnsavedChangesWarning`
 * registers its dirty-check here, so app-level code that wants to reload the
 * page (chunk-load recovery, the new-version reload) can ask the same question
 * the `beforeunload` guard answers — and wait instead of tripping the
 * browser's "Leave site?" dialog mid-save.
 */
const dirtyGetters = new Set<() => boolean>();

export function registerUnsavedWork(isDirty: () => boolean): () => void {
  dirtyGetters.add(isDirty);
  return () => {
    dirtyGetters.delete(isDirty);
  };
}

export function hasUnsavedWork(): boolean {
  for (const isDirty of dirtyGetters) {
    if (isDirty()) return true;
  }
  return false;
}
